module.exports = __webpack_public_path__ + "img/img_throw_5@3x_v3.3a313285.png";